/**
 * Request model sent as the `filters` payload to `liveListApi.get`.
 */
export class LiveListFilters {
	pageSize = null;

	pageNumber = null;

	searchTerm = null;

	constructor({ pageSize = null, pageNumber = null, searchTerm = null } = {}) {
		this.pageSize = pageSize;
		this.pageNumber = pageNumber;
		this.searchTerm = searchTerm;
	}
}
